import { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';

// Contextos
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

// Estilos
import styles from './loginpage.module.css';

function LoginPage() {
    const { login, isAuthenticated } = useAuth();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [telefone, setTelefone] = useState('');
    const [senha, setSenha] = useState('');
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(false);

    const telefoneInputRef = useRef(null);

    // 📱 Máscara de celular
    const formatarCelular = (valor) => {
        const numeros = valor.replace(/\D/g, '').slice(0, 11);
        const parte1 = numeros.slice(0, 2);
        const parte2 = numeros.slice(2, 7);
        const parte3 = numeros.slice(7, 11);

        if (numeros.length <= 2) return `(${parte1}`;
        if (numeros.length <= 7) return `(${parte1}) ${parte2}`;
        return `(${parte1}) ${parte2}-${parte3}`;
    };

    const handleTelefoneChange = (e) => {
        const valor = e.target.value.replace(/\D/g, '');
        if (valor.length <= 11) {
            setTelefone(formatarCelular(valor));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setCarregando(true);
        setErro('');

        const telefoneSemMascara = telefone.replace(/\D/g, '');

        if (telefoneSemMascara.length !== 11) {
            showToast('O telefone deve conter 11 dígitos!', 3000, 'error');
            setCarregando(false);
            return;
        }

        const result = await login(telefoneSemMascara, senha);

        if (result.success) {
            showToast('Login realizado com sucesso!', 3000, 'success');
            navigate('/home');
        } else {
            showToast('Falha no login.', 3000, 'error');
            setErro(result.message || 'Falha no login');
        }

        setCarregando(false);
    };

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        telefoneInputRef.current?.focus();
    }, []);

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Login</h2>

            <form onSubmit={handleSubmit} className={styles.form}>
                <input
                    type="tel"
                    ref={telefoneInputRef}
                    placeholder="(11) 91234-5678"
                    value={telefone}
                    onChange={handleTelefoneChange}
                    className={styles.input}
                    required
                />

                <input
                    type="password"
                    placeholder="Senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    className={styles.input}
                    required
                />

                <button type="submit" className={styles.button} disabled={carregando}>
                    {carregando ? 'Entrando...' : 'Entrar'}
                </button>

                {erro && <p className={styles.error}>{erro}</p>}

                <Link to="/recuperar" className={styles.link}>
                    Esqueceu sua senha?
                </Link>
            </form>
        </div>
    );
}

export default LoginPage;